import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DownloadCourseContentSlice {
  enrolledId: string
  learningSpaceId: string
}

const initialState: DownloadCourseContentSlice = {
  enrolledId: '',
  learningSpaceId: ''
}

const downloadCourseContentDialogSlice = createSlice({
  name: 'downloadCourseContentDialog',
  initialState,
  reducers: {
    setEnrolledId(state, action: PayloadAction<string>) {
      state.enrolledId = action.payload
    },
    setLearningSpaceId(state, action: PayloadAction<string>) {
      state.learningSpaceId = action.payload
    },
    setDownloadCourseContentData(
      _,
      action: PayloadAction<DownloadCourseContentSlice>
    ) {
      return action.payload
    },
    resetDialog(state) {
      state.enrolledId = ''
      state.learningSpaceId = ''
    }
  }
})

export const {
  setEnrolledId,
  setLearningSpaceId,
  resetDialog,
  setDownloadCourseContentData
} = downloadCourseContentDialogSlice.actions

// Selector function
export const selectDownloadCourseContentDialog = (state: {
  downloadCourseContentDialog: DownloadCourseContentSlice
}) => state.downloadCourseContentDialog

export default downloadCourseContentDialogSlice.reducer
